/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompleteTaskRequest,
  ContactNoteResponse,
  CreateTaskAttachment200Response,
  DistributeDocumentsRequest,
  DistributeDocumentsRequestBulk,
  DistributeDocumentsResponse,
  DocumentRedistributionRequest,
  MultipleDistributionItem,
  ServiceAgreementV2,
} from '../models/index';
import {
    CompleteTaskRequestFromJSON,
    CompleteTaskRequestToJSON,
    ContactNoteResponseFromJSON,
    ContactNoteResponseToJSON,
    CreateTaskAttachment200ResponseFromJSON,
    CreateTaskAttachment200ResponseToJSON,
    DistributeDocumentsRequestFromJSON,
    DistributeDocumentsRequestToJSON,
    DistributeDocumentsRequestBulkFromJSON,
    DistributeDocumentsRequestBulkToJSON,
    DistributeDocumentsResponseFromJSON,
    DistributeDocumentsResponseToJSON,
    DocumentRedistributionRequestFromJSON,
    DocumentRedistributionRequestToJSON,
    MultipleDistributionItemFromJSON,
    MultipleDistributionItemToJSON,
    ServiceAgreementV2FromJSON,
    ServiceAgreementV2ToJSON,
} from '../models/index';

export interface CompleteFlowableTaskRequest {
    serviceAgreementUid: string;
    completeTaskRequest: CompleteTaskRequest;
}

export interface CreateTaskAttachmentRequest {
    serviceAgreementUid: string;
    taskUid: string;
    file?: Blob;
}

export interface DeleteTaskAttachmentRequest {
    serviceAgreementUid: string;
    taskUid: string;
}

export interface DistributeDocumentsOperationRequest {
    serviceAgreementUid: string;
    distributeDocumentsRequest: DistributeDocumentsRequest;
}

export interface DistributeDocumentsBulkRequest {
    brUid: string;
    distributeDocumentsRequestBulk: DistributeDocumentsRequestBulk;
}

export interface GetContactNotesByBrRequest {
    brUid: string;
}

export interface GetDocumentsToDistributeRequest {
    brId: string;
}

export interface GetTaskAttachmentRequest {
    serviceAgreementUid: string;
    taskUid: string;
}

export interface RedistributeDocumentListRequest {
    brId: string;
    documentRedistributionRequest: DocumentRedistributionRequest;
}

/**
 * 
 */
export class TaskApi extends runtime.BaseAPI {

    /**
     * Creates request options for completeFlowableTask without sending the request
     */
    async completeFlowableTaskRequestOpts(requestParameters: CompleteFlowableTaskRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling completeFlowableTask().'
            );
        }

        if (requestParameters['completeTaskRequest'] == null) {
            throw new runtime.RequiredError(
                'completeTaskRequest',
                'Required parameter "completeTaskRequest" was null or undefined when calling completeFlowableTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/task/{serviceAgreementUid}/complete`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteTaskRequestToJSON(requestParameters['completeTaskRequest']),
        };
    }

    /**
     * Complete flowable task
     */
    async completeFlowableTaskRaw(requestParameters: CompleteFlowableTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementV2>> {
        const requestOptions = await this.completeFlowableTaskRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementV2FromJSON(jsonValue));
    }

    /**
     * Complete flowable task
     */
    async completeFlowableTask(requestParameters: CompleteFlowableTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementV2> {
        const response = await this.completeFlowableTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createTaskAttachment without sending the request
     */
    async createTaskAttachmentRequestOpts(requestParameters: CreateTaskAttachmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling createTaskAttachment().'
            );
        }

        if (requestParameters['taskUid'] == null) {
            throw new runtime.RequiredError(
                'taskUid',
                'Required parameter "taskUid" was null or undefined when calling createTaskAttachment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/task/{serviceAgreementUid}/attachment/{taskUid}`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));
        urlPath = urlPath.replace(`{${"taskUid"}}`, encodeURIComponent(String(requestParameters['taskUid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     * Create attachment for task entity
     */
    async createTaskAttachmentRaw(requestParameters: CreateTaskAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTaskAttachment200Response>> {
        const requestOptions = await this.createTaskAttachmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateTaskAttachment200ResponseFromJSON(jsonValue));
    }

    /**
     * Create attachment for task entity
     */
    async createTaskAttachment(requestParameters: CreateTaskAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTaskAttachment200Response> {
        const response = await this.createTaskAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteTaskAttachment without sending the request
     */
    async deleteTaskAttachmentRequestOpts(requestParameters: DeleteTaskAttachmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling deleteTaskAttachment().'
            );
        }

        if (requestParameters['taskUid'] == null) {
            throw new runtime.RequiredError(
                'taskUid',
                'Required parameter "taskUid" was null or undefined when calling deleteTaskAttachment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/task/{serviceAgreementUid}/attachment/{taskUid}`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));
        urlPath = urlPath.replace(`{${"taskUid"}}`, encodeURIComponent(String(requestParameters['taskUid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete attachment for task entity
     */
    async deleteTaskAttachmentRaw(requestParameters: DeleteTaskAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteTaskAttachmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete attachment for task entity
     */
    async deleteTaskAttachment(requestParameters: DeleteTaskAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTaskAttachmentRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for distributeDocuments without sending the request
     */
    async distributeDocumentsRequestOpts(requestParameters: DistributeDocumentsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling distributeDocuments().'
            );
        }

        if (requestParameters['distributeDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'distributeDocumentsRequest',
                'Required parameter "distributeDocumentsRequest" was null or undefined when calling distributeDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/task/{serviceAgreementUid}/distribute-documents`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributeDocumentsRequestToJSON(requestParameters['distributeDocumentsRequest']),
        };
    }

    /**
     * Complete task and send distribution request
     */
    async distributeDocumentsRaw(requestParameters: DistributeDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DistributeDocumentsResponse>> {
        const requestOptions = await this.distributeDocumentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributeDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * Complete task and send distribution request
     */
    async distributeDocuments(requestParameters: DistributeDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DistributeDocumentsResponse> {
        const response = await this.distributeDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for distributeDocumentsBulk without sending the request
     */
    async distributeDocumentsBulkRequestOpts(requestParameters: DistributeDocumentsBulkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling distributeDocumentsBulk().'
            );
        }

        if (requestParameters['distributeDocumentsRequestBulk'] == null) {
            throw new runtime.RequiredError(
                'distributeDocumentsRequestBulk',
                'Required parameter "distributeDocumentsRequestBulk" was null or undefined when calling distributeDocumentsBulk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/task/{brUid}/distribute-documents/bulk`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributeDocumentsRequestBulkToJSON(requestParameters['distributeDocumentsRequestBulk']),
        };
    }

    /**
     * Complete task and send distribution request bulk operation
     */
    async distributeDocumentsBulkRaw(requestParameters: DistributeDocumentsBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DistributeDocumentsResponse>> {
        const requestOptions = await this.distributeDocumentsBulkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributeDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * Complete task and send distribution request bulk operation
     */
    async distributeDocumentsBulk(requestParameters: DistributeDocumentsBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DistributeDocumentsResponse> {
        const response = await this.distributeDocumentsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getContactNotesByBr without sending the request
     */
    async getContactNotesByBrRequestOpts(requestParameters: GetContactNotesByBrRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling getContactNotesByBr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/task/{brUid}/contact-notes`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * getContactNotes for input Br
     */
    async getContactNotesByBrRaw(requestParameters: GetContactNotesByBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactNoteResponse>> {
        const requestOptions = await this.getContactNotesByBrRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactNoteResponseFromJSON(jsonValue));
    }

    /**
     * getContactNotes for input Br
     */
    async getContactNotesByBr(requestParameters: GetContactNotesByBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactNoteResponse> {
        const response = await this.getContactNotesByBrRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDocumentsToDistribute without sending the request
     */
    async getDocumentsToDistributeRequestOpts(requestParameters: GetDocumentsToDistributeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brId'] == null) {
            throw new runtime.RequiredError(
                'brId',
                'Required parameter "brId" was null or undefined when calling getDocumentsToDistribute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/task/{brId}/todistribute`;
        urlPath = urlPath.replace(`{${"brId"}}`, encodeURIComponent(String(requestParameters['brId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all documents for service agreements in status ready for distribution for the BR {brId}
     * Get all documents for service agreements/service role in status ready for distribution for the BR
     */
    async getDocumentsToDistributeRaw(requestParameters: GetDocumentsToDistributeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MultipleDistributionItem>>> {
        const requestOptions = await this.getDocumentsToDistributeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MultipleDistributionItemFromJSON));
    }

    /**
     * Get all documents for service agreements in status ready for distribution for the BR {brId}
     * Get all documents for service agreements/service role in status ready for distribution for the BR
     */
    async getDocumentsToDistribute(requestParameters: GetDocumentsToDistributeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MultipleDistributionItem>> {
        const response = await this.getDocumentsToDistributeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTaskAttachment without sending the request
     */
    async getTaskAttachmentRequestOpts(requestParameters: GetTaskAttachmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling getTaskAttachment().'
            );
        }

        if (requestParameters['taskUid'] == null) {
            throw new runtime.RequiredError(
                'taskUid',
                'Required parameter "taskUid" was null or undefined when calling getTaskAttachment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/task/{serviceAgreementUid}/attachment/{taskUid}`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));
        urlPath = urlPath.replace(`{${"taskUid"}}`, encodeURIComponent(String(requestParameters['taskUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get attachment for task entity
     */
    async getTaskAttachmentRaw(requestParameters: GetTaskAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.getTaskAttachmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get attachment for task entity
     */
    async getTaskAttachment(requestParameters: GetTaskAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getTaskAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for redistributeDocumentList without sending the request
     */
    async redistributeDocumentListRequestOpts(requestParameters: RedistributeDocumentListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brId'] == null) {
            throw new runtime.RequiredError(
                'brId',
                'Required parameter "brId" was null or undefined when calling redistributeDocumentList().'
            );
        }

        if (requestParameters['documentRedistributionRequest'] == null) {
            throw new runtime.RequiredError(
                'documentRedistributionRequest',
                'Required parameter "documentRedistributionRequest" was null or undefined when calling redistributeDocumentList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/task/{brId}/redistribute`;
        urlPath = urlPath.replace(`{${"brId"}}`, encodeURIComponent(String(requestParameters['brId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentRedistributionRequestToJSON(requestParameters['documentRedistributionRequest']),
        };
    }

    /**
     * Redistribute documents
     */
    async redistributeDocumentListRaw(requestParameters: RedistributeDocumentListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.redistributeDocumentListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Redistribute documents
     */
    async redistributeDocumentList(requestParameters: RedistributeDocumentListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.redistributeDocumentListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
